import { Box, Typography } from "@mui/material";
import React from "react";

const Tag = ({ label, style, icon, textStyle }) => {
  return (
    <Box
      sx={{
        borderRadius: "16px",
        backgroundColor: "#f0f0f0",
        ...style
     
      }}
    >
      {icon && icon}
      <Typography sx={textStyle}>{label || "Tag"}</Typography>
    </Box>
  );
};

export default Tag;
